import { useEffect, useState } from 'react';

export function EmailVerified() {
  const [mounted, setMounted] = useState(false);
  const [checkVisible, setCheckVisible] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  const [subtitleVisible, setSubtitleVisible] = useState(false);
  const [hintVisible, setHintVisible] = useState(false);

  useEffect(() => {
    setMounted(true);
    const t1 = setTimeout(() => setCheckVisible(true), 300);
    const t2 = setTimeout(() => setTextVisible(true), 800);
    const t3 = setTimeout(() => setSubtitleVisible(true), 1100);
    const t4 = setTimeout(() => setHintVisible(true), 1600);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50 dark:from-zinc-950 dark:via-zinc-900 dark:to-emerald-950/20 flex items-center justify-center p-6">
      {/* Subtle background decoration */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-emerald-200/30 dark:bg-emerald-800/10 blur-3xl"
          style={{
            opacity: mounted ? 1 : 0,
            transition: 'opacity 2s ease-out',
          }}
        />
        <div
          className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-blue-200/20 dark:bg-blue-800/10 blur-3xl"
          style={{
            opacity: mounted ? 1 : 0,
            transition: 'opacity 2s ease-out 0.5s',
          }}
        />
      </div>

      <div className="relative text-center max-w-md">
        {/* Animated checkmark */}
        <div
          className="relative mx-auto w-24 h-24 mb-8"
          style={{
            opacity: checkVisible ? 1 : 0,
            transform: checkVisible ? 'scale(1)' : 'scale(0.5)',
            transition: 'opacity 0.6s ease-out, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
          }}
        >
          {/* Outer ring pulse */}
          <div className="absolute inset-0 rounded-full bg-emerald-400/20 dark:bg-emerald-400/10 animate-ping" style={{ animationDuration: '2s' }} />
          {/* Middle ring */}
          <div
            className="absolute -inset-3 rounded-full border-2 border-emerald-300/40 dark:border-emerald-500/20"
            style={{
              opacity: checkVisible ? 1 : 0,
              transform: checkVisible ? 'scale(1)' : 'scale(0.8)',
              transition: 'opacity 0.8s ease-out 0.3s, transform 0.8s ease-out 0.3s',
            }}
          />
          {/* Circle */}
          <div className="relative w-full h-full rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 dark:from-emerald-500 dark:to-emerald-700 shadow-lg shadow-emerald-500/25 flex items-center justify-center">
            <svg
              className="w-12 h-12 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M5 13l4 4L19 7"
                className="animate-[draw_0.4s_ease-out_0.5s_forwards]"
                style={{
                  strokeDasharray: 24,
                  strokeDashoffset: 24,
                }}
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1
          className="text-3xl font-bold text-zinc-900 dark:text-zinc-100 mb-3"
          style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? 'translateY(0)' : 'translateY(12px)',
            transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
          }}
        >
          Email verified
        </h1>

        {/* Subtitle */}
        <p
          className="text-lg text-zinc-500 dark:text-zinc-400 mb-10"
          style={{
            opacity: subtitleVisible ? 1 : 0,
            transform: subtitleVisible ? 'translateY(0)' : 'translateY(8px)',
            transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
          }}
        >
          You're all set to send invoices and quotes.
        </p>

        {/* Hint to go back */}
        <div
          style={{
            opacity: hintVisible ? 1 : 0,
            transform: hintVisible ? 'translateY(0)' : 'translateY(8px)',
            transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
          }}
        >
          <div className="inline-flex items-center gap-2 px-5 py-3 rounded-2xl bg-white/80 dark:bg-zinc-800/80 backdrop-blur border border-zinc-200/60 dark:border-zinc-700/60 shadow-sm">
            <svg className="w-4 h-4 text-zinc-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 5l-7 7 7 7" />
            </svg>
            <span className="text-sm text-zinc-500 dark:text-zinc-400">
              Head back to your other tab to continue
            </span>
          </div>
        </div>
      </div>

      {/* CSS for checkmark animation */}
      <style>{`
        @keyframes draw {
          to {
            stroke-dashoffset: 0;
          }
        }
      `}</style>
    </div>
  );
}
